import { IFormElementsState } from '../store/reducers/formElementsReducer';
import store from '../store/index';
import { FORM_FIELD_TYPE_CODE } from '../constants/formElements';

export interface IField {
  fieldCode: string;
  value: any;
}

export const mapDataBeforeSave = (fields: Dict<any>, customFields: string[] = []): any[] => {
  const fieldInputTypeDict: IFormElementsState = store.getState().formElements;

  const data = Object.entries(fields).reduce((acc: IField[], [fieldCode, value]): any => {
    if (customFields.includes(fieldCode)) {
      const customFieldsObjectIndex = acc.findIndex(
        (field: IField) => field.fieldCode === 'customFields',
      );
      if (customFieldsObjectIndex === -1) {
        return [
          ...acc,
          {
            fieldCode: 'customFields',
            value: {
              [fieldCode]: value,
            },
          },
        ];
      }
      acc[customFieldsObjectIndex] = {
        ...acc[customFieldsObjectIndex],
        value: {
          ...acc[customFieldsObjectIndex].value,
          [fieldCode]: value,
        },
      };

      return [...acc];
    }
    switch (fieldInputTypeDict[fieldCode]) {
      case FORM_FIELD_TYPE_CODE.NATIONALITY_SELECT: {
        return value ? [...acc, { fieldCode, value: [value] }] : [...acc, { fieldCode, value: [] }];
      }

      case FORM_FIELD_TYPE_CODE.EVENT_MULTI_SELECT:
      case FORM_FIELD_TYPE_CODE.STATE_MULTI_SELECT: {
        return value?.length > 0
          ? [...acc, { fieldCode, value: value.toString() }]
          : [...acc, { fieldCode, value: '' }];
      }

      case FORM_FIELD_TYPE_CODE.NATIVE_RESIDENT_SELECT: {
        return [...acc, { fieldCode, value: !!value }];
      }

      default: {
        if (!value) {
          return acc;
        }

        return [...acc, { fieldCode, value }];
      }
    }
  }, []);

  const nativeResident = data.find((item) => item.fieldCode === 'nativeResident');
  const payload = data
    .map((item) => {
      if (!(item.fieldCode === 'state' && !nativeResident?.value)) {
        return item;
      }

      return item;
    })
    .filter((x) => x !== undefined);

  return payload;
};

export const countLastValidStep = (fields: IField[]): number => {
  const { steps } = store.getState().formConfig;
  const fieldsValues: Dict<any> = fields.reduce(
    (acc, current) => ({ ...acc, [current.fieldCode]: current.value }),
    {},
  );

  let lastValidStep: number | null = null;

  steps.forEach((step, stepIndex) => {
    (step.sections ?? []).forEach((section) => {
      (section.elements ?? []).forEach((element) => {
        if (!lastValidStep && element.required && !fieldsValues[element.fieldCode]) {
          lastValidStep = stepIndex;
        }
      });
    });
  });

  return lastValidStep ?? steps.length;
};

export const getLabel = (label, required) => (label && required ? `${label} *` : label || '');
